"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchAddressToJSON = exports.SearchAddressFromJSONTyped = exports.SearchAddressFromJSON = void 0;
function SearchAddressFromJSON(json) {
    return SearchAddressFromJSONTyped(json, false);
}
exports.SearchAddressFromJSON = SearchAddressFromJSON;
function SearchAddressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'additional': json['additional'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'countryCode': json['countryCode'],
    };
}
exports.SearchAddressFromJSONTyped = SearchAddressFromJSONTyped;
function SearchAddressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'additional': value.additional,
        'houseNumber': value.houseNumber,
        'zipCode': value.zipCode,
        'countryCode': value.countryCode,
    };
}
exports.SearchAddressToJSON = SearchAddressToJSON;
//# sourceMappingURL=SearchAddress.js.map